/**
 * 通用API接口
 * 包含分享、统计等通用功能
 */
import request from '@/bootstarp/request';
// 分享统计接口
export interface IShareRequest {
  resourceType: string;
  resourceId: string | number;
}

export interface IShareResponse {
  status: number;
  message?: string;
  data?: any;
}





/**
 * 发送分享统计请求
 * @param params 分享参数
 * @returns Promise<IShareResponse>
 */
export const shareResource = (params: IShareRequest) => {
  return request.course.get<IShareResponse>(
    `/integration/share/${params.resourceType}/${params.resourceId}`,
  );
};

/**
 * 分享到微博
 * @param url 分享链接
 * @param title 分享标题
 */
export const shareToWeibo = (url: string, title: string) => {
  const shareUrl = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`;
  window.open(shareUrl, '_blank');
};

/**
 * 分享到QQ
 * @param url 分享链接
 * @param title 分享标题
 */
export const shareToQQ = (url: string, title: string) => {
  const shareUrl = `http://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(url)}&sharesource=qzone&title=${encodeURIComponent(title)}&desc=${encodeURIComponent(title)}&summary=${encodeURIComponent(title)}`;
  window.open(shareUrl, '_blank');
};

// 关注接口相关类型定义
export interface IAttentionRequest {
  type: string | number;
  attentionStatus: 'Y' | 'N';
}

export interface IAttentionResponse {
  status: number;
  message?: string;
  data?: any;
}

/**
 * 关注/取消关注接口
 * @param type 类型值，由props传入
 * @param attentionStatus 关注状态，Y表示关注，N表示取消关注
 * @returns Promise<IAttentionResponse>
 */
export const updateAttention = (
  type: string | number,
  attentionStatus: 'Y' | 'N',
  id: string | number,
) => {
  return request.course.put<IAttentionResponse>(
    `/${type}/${id}/attention?attentionStatus=${attentionStatus}`,
  );
};

/**
 * @desc 检索接口
 */
export const fetchQueryList = (params: {
  pageIndex: number;
  pageSize: number;
  type?: string;
  isSkillMaster?: 0 | 1;
  problemSearchType?: 0 | 1 | 2 | 3 | 4;
  sort?:
    | 'isRecommend'
    | 'publishDate'
    | 'orderFlag'
    | 'praiseCount'
    | 'viewCount'
    | 'likeCount'
    | 'replyCount'
    | 'addTime'
    | 'readCount';
}) => {
  return request.course.get(`/permit/query`, {
    params,
  });
};

/**
 * @desc 是否需要升级浏览器
 */

export const fetchIsNeedUpgradeBrowser = () => {
  return request.course.get(`/permit/browser/download`);
};



/**
 * @desc 获取首页json数据
 */

export const fetchHomeJson = () => {
  return request.json(`index.json`);
};
